import { Text, View } from '@react-pdf/renderer';

import { PublicEventDetailsResponse } from '@hubs101/booking-api-skd-client/lib/types';
import dayjs from 'dayjs';
import { splitArrayBySubtitleLengthFunctional } from '@utils/fn';
import { styles } from '../../styles';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface KeyTopicsProps {
  event: PublicEventDetailsResponse;
}

export interface KeyTopicItem {
  title: string;
  subtitle: string;
  order: number;
}
const KeyTopics = ({ event }: KeyTopicsProps) => {
  const { t } = useTranslation();

  const eventKeyTopicsItems = useMemo(
    () =>
      event?.website_content?.keytopics
        ?.filter(e => e.published)
        .sort((a, b) => a.order - b.order)
        ?.map(keyTopic => ({
          title: keyTopic.title,
          subtitle: keyTopic.description,
          order: keyTopic.order,
        })),
    [event?.website_content?.keytopics]
  );

  const splitEventKeyTopicsItems = useMemo(
    () => splitArrayBySubtitleLengthFunctional(eventKeyTopicsItems, 1900),
    [eventKeyTopicsItems]
  );

  return (
    <View>
      <View
        style={{
          ...styles.rightSideBody,
          gap: 20,
          alignItems: 'flex-start',
        }}
      >
        <Text style={styles.bodyTitle}>{t('key-topics')}</Text>
        <View style={styles.bodyLineBar} />

        <Text style={styles.eventTitle}>
          {`${t('the')} ${event?.name} ${dayjs(event?.start_date).format('YYYY')}`}
        </Text>
      </View>
      <View style={styles.keyTopicsWrapper}>
        {splitEventKeyTopicsItems?.map((column: KeyTopicItem[]) => (
          <View style={styles.keyTopicsColumn} key={column[0].order}>
            {column?.map(item => (
              <View style={styles.keyTopicsItem} key={item.order}>
                <Text style={styles.lightText}>•</Text>
                <Text style={styles.lightText}>
                  {item.title}: {item.subtitle}
                </Text>
              </View>
            ))}
          </View>
        ))}
      </View>
    </View>
  );
};

export default KeyTopics;
